import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Space } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createSpaceApi, spaceKeys } from '../api';

export function useSpace(id: string, enabled = true): UseQueryResult<Space> {
  const client = useApiClient('admin-auth');
  const api = createSpaceApi(client);

  return useQuery({
    enabled: enabled && !!id,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getSpace(id),
    queryKey: spaceKeys.detail(id),
    staleTime: LIST_STALE_TIME_MS,
  });
}
